import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["content", "icon", "button"]

    connect() {
        this.setCollapsedState(true)
    }

    toggle(event) {
        event.preventDefault()
        const isCollapsed = this.contentTarget.hasAttribute('hidden')
        this.setCollapsedState(!isCollapsed)
    }

    setCollapsedState(shouldCollapse) {
        if (shouldCollapse) {
            this.contentTarget.setAttribute('hidden', '')
            this.buttonTarget.setAttribute('aria-expanded', 'false')
            this.iconTarget.classList.remove('series-toggle__icon--expanded')
        } else {
            this.contentTarget.removeAttribute('hidden')
            this.buttonTarget.setAttribute('aria-expanded', 'true')
            this.iconTarget.classList.add('series-toggle__icon--expanded')
        }
    }
}
